import React, { useEffect, useState, useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { bigStats } from '../mock/mock';

export const Counter = ({ to, suffix = '', duration = 2 }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });
  const [val, setVal] = useState(0);

  useEffect(() => {
    if (!isInView) return;
    let start = 0;
    const end = to;
    const stepTime = 16;
    const steps = (duration * 1000) / stepTime;
    const inc = end / steps;
    const iv = setInterval(() => {
      start += inc;
      if (start >= end) { start = end; clearInterval(iv); }
      setVal(start);
    }, stepTime);
    return () => clearInterval(iv);
  }, [isInView, to, duration]);

  const isFloat = to % 1 !== 0;
  const display = isFloat ? val.toFixed(1) : Math.floor(val);
  return <span ref={ref}>{display}{suffix}</span>;
};

const StatsBanner = () => {
  return (
    <section className="relative py-20 overflow-hidden section-mesh">
      <div className="absolute inset-0 grid-bg opacity-20" />

      <div className="container-x px-6 relative">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <div className="eyebrow mb-4"><span className="w-1.5 h-1.5 rounded-full bg-cyan-400" /> Trusted Globally</div>
          <h2 className="section-title">Trusted by more than <span className="gradient-text">10K users</span></h2>
          <p className="section-subtitle mx-auto mt-4">Leading organizations worldwide rely on us for secure, scalable and reliable infrastructure.</p>
        </div>

        <div className="grid grid-cols-3 gap-8 max-w-4xl mx-auto">
          {bigStats.map((s, i) => (
            <motion.div
              key={s.label}
              initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.15 }}
              className="text-center p-6 rounded-2xl glass"
            >
              <div className="text-4xl md:text-6xl font-extrabold gradient-text">
                <Counter to={s.value} suffix={s.suffix} />
              </div>
              <div className="mt-2 text-sm text-cyan-300 uppercase tracking-widest">{s.label}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsBanner;
